<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- Per Page -->
            <list-per-page
              :total="total"
              :current-per-page="perPage"
              @onChangePerPage="changePerPage"
            />
            <div v-if="!loader">
              <div
                v-if="additionalData.groups && additionalData.groups.length"
              >
                <b-button
                  variant="success"
                  @click="createButtonClicked"
                >
                  {{ $t('add contact') }}
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <b-button
                  variant="warning"
                  class="ml-1"
                  @click="$router.push({name:'contacts-import'})"
                >
                  {{ $t('import contacts') }}
                  <feather-icon icon="FilePlusIcon" />
                </b-button>
                <b-button
                  class="ml-1"
                  variant="success"
                  :disabled="excelSpinner"
                  @click="downloadExcel"
                >
                  <b-spinner
                    v-if="excelSpinner"
                    small
                  />
                  {{ $t('Download excel') }}
                  <feather-icon icon="FileTextIcon" />
                </b-button>
              </div>
              <div
                v-else
              >
                <b-button
                  variant="success"
                  @click="createGroup"
                >
                  {{ $t('add group') }}
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </div>
            </div>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <list-search @onSearch="search" />
            </div>
          </b-col>
        </b-row>
      </div>
      <table-loader v-if="loader" />
      <div v-else>
        <b-row v-if="!additionalData.groups && !additionalData.groups.length">
          <b-col
            md="6"
            offset-md="3"
          >
            <b-alert
              show
              variant="danger"
            >

              <div class="alert-body">
                <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-50"
                />
                <span class="font-weight-bolder">{{ $t('To create an contact, you must first create a group') }}</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <contacts-list
          :fields="fields"
          :items="items"
          :additional-data="additionalData"
          @onItemCreated="getData"
          @onItemUpdated="getData"
          @onDeleteButtonClicked="deleteButtonClicked"
        />

        <list-pagination
          :current="page"
          :current-per-page="perPage"
          :from="from"
          :to="to"
          :total="total"
          :total-page="totalPage"
          @onChangePage="changePage"
        />
      </div>
    </div>
  </b-card>

</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import ContactsList from '../../components/contacts/list/ContactsList'

export default {
  components: {
    ContactsList,
  },
  mixins: [ListIndex],
  props: {
    id: {
      type: [String, Number],
      default: () => '',
    },
  },
  data() {
    return {
      routeName: 'contacts',
      userFields: [
        {
          key: 'name',
          label: this.$t('Contact name'),
        },
        {
          key: 'phone',
          label: this.$t('Phone'),
        },
        {
          key: 'group',
          label: this.$t('Group name'),
        },
        {
          key: 'message_count',
          label: this.$t('Message count'),
        },
        {
          key: 'city',
          label: this.$t('City'),
        },
        {
          key: 'company',
          label: this.$t('Company'),
        },
        {
          key: 'gender',
          label: this.$t('Gender'),
        },
        {
          key: 'birthday',
          label: this.$t('Birthday'),
        },
        {
          key: 'created_at',
          label: this.$t('Created At'),
        },
        {
          label: '',
          key: 'action',
        },
      ],
    }
  },
  created() {
    if (this.id) this.customParams.group_id = this.id
  },
  methods: {
    createGroup() {
      setTimeout(() => {
        this.$bvModal.show('groups-edit-modal')
      }, 500)
    },
  },
}
</script>

<style lang="scss">

</style>
